import {Component} from '@angular/core';

@Component({
    selector: 'app-admin-service',
    templateUrl: './admin-service.component.html',
    styleUrls: ['./admin-service.component.scss'],
    standalone: false
})
export class AdminServiceComponent {
}
